import type {
  CustomEvent,
  DebugEvent,
  ErrorEvent,
  InternalEvent,
  InternalTimingEvent,
  InternalValueEvent,
  LoggedEvent,
  UserInteractionEvent,
  WarningEvent,
} from '../loggingTypes';
import { LoggingEventType } from '../loggingTypes';

export interface TestLoggingContext {
  errorCode: number;
  site: string;
  buildNumber: number;
  locale: string;
  empty: string;
  incrementValue: number;
  exclude: boolean;
}

export const testLoggingContext: Partial<TestLoggingContext> = {
  errorCode: 500,
  site: 'snap.com',
  buildNumber: 68731,
  locale: 'en-US',
};

export interface TestPageLoadEvent {
  pathname: string;
  customType: 'page_load';
}

export interface TestNavigateEvent {
  url: string;
  customType: 'navigate';
  durationMs: number;
}

export type TestCustomEvent = TestPageLoadEvent | TestNavigateEvent;

export const testPageLoadEvent: CustomEvent<TestPageLoadEvent> = {
  type: LoggingEventType.CUSTOM,
  pathname: '/',
  customType: 'page_load',
};

export const testNavigateEvent: CustomEvent<TestNavigateEvent> = {
  type: LoggingEventType.CUSTOM,
  url: 'https://snap.com',
  customType: 'navigate',
  durationMs: 523,
};

export const testErrorEvent: ErrorEvent = {
  component: 'Test',
  message: 'Unable to read "e" of undefined.',
  type: LoggingEventType.ERROR,
  error: new Error('Some error'),
};

export const testUserInteractionEvent: UserInteractionEvent = {
  type: LoggingEventType.USER_ACTION,
  label: 'test label',
  action: 'test action',
  component: 'test category',
};

export const testWarningEvent: WarningEvent = {
  type: LoggingEventType.WARNING,
  component: 'Contentful',
  message: 'Returned status code 429. Retrying',
};

export const testInternalEvent: InternalEvent = {
  type: LoggingEventType.INFO,
  component: 'Image',
  label: '23562sdfwe',
  action: 'loaded',
};

export const testInternalTimingEvent: InternalTimingEvent = {
  type: LoggingEventType.TIMING,
  component: 'Video',
  label: '03249867dkjfg',
  variable: 'load_latency',
  valueMs: 700,
};

export const testInternalValueEvent: InternalValueEvent = {
  type: LoggingEventType.VALUE,
  component: 'Video',
  label: '03249867dkjfg',
  variable: 'bytes_downloaded',
  value: 1_234_456,
};

export const testDebugEvent: DebugEvent = {
  type: LoggingEventType.DEBUG,
  component: 'Button',
  message: 'Hovered over button 2034687gfzks5',
};

export const testEvents: Array<LoggedEvent<TestCustomEvent>> = [
  testErrorEvent,
  testUserInteractionEvent,
  testWarningEvent,
  testDebugEvent,
  testInternalEvent,
  testInternalValueEvent,
  testInternalTimingEvent,
  testPageLoadEvent,
  testNavigateEvent,
];
